var CheckoutState;
(function(CheckoutState) {
    CheckoutState["InProgress"] = "InProgress";
    CheckoutState["ReadyToOrder"] = "ReadyToOrder";
    CheckoutState["Finalized"] = "Finalized";
})(CheckoutState || (CheckoutState = {}));

export { CheckoutState };
//# sourceMappingURL=checkoutState.js.map
